import { Flashcard } from "./flashcard.model";

export class Learnset {
  id: number | null;
  userId: number | null;
  name: string;
  courseId?: number | null;
  openCards?: number;
  masteredCardsCount?: number;
  flashcards: Flashcard[] = [];
  courseName: string | null;
  smartRepetitionEnabled?: boolean;

  constructor(id: number | null, userId: number | null, name: string, courseId: number, openCards: number, masteredCardsCount: number, flashcards: any[], courseName: string | null, smartRepetitionEnabled: boolean) {
    this.id = id;
    this.userId = userId;
    this.name = name;
    this.courseId = courseId;
    this.openCards = openCards;
    this.masteredCardsCount = masteredCardsCount;
    this.flashcards = flashcards.map(flashcard => Flashcard.constructFlashcard(flashcard));
    this.courseName = courseName;
    this.smartRepetitionEnabled = smartRepetitionEnabled;
  }

  public static constructLearnset(raw: any): Learnset {
    return new Learnset(
      raw.id,
      raw.userId,
      raw.name,
      raw.courseId,
      raw.openCards,
      raw.masteredCardsCount,
      raw.flashcards?.length > 0 ? raw.flashcards.map((flashcard: any) => Flashcard.constructFlashcard(flashcard)) : [],
      raw.course?.name,
      raw.smartRepetitionEnabled
    );
  }
}